import React from 'react'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

export const ResultChartComponent = ({ subject, labels, datasetLabel, datasetData, max }) => {
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const index = context.dataIndex // 데이터의 인덱스
                        const label = datasetLabel[index][subject] // labels 배열에서 해당 인덱스의 값 가져오기
                        const value = context.raw // 해당 막대의 값
                        return `${label}: ${value} 점` // 툴팁 커스터마이징
                    },
                },
            },
        },
        scales: {
            y: {
                min: 0,
                max: max,
            },
        },
    }

    const data = {
        labels,
        datasets: [
            {
                data: datasetData.map((item) => item[subject]),
                backgroundColor: '#D97706',
                // backgroundColor: 'rgba(13, 110, 253, 0.7)',
                barThickness: 40,
            },
        ],
    }

    return (
        <div>
            <Bar
                options={options}
                data={data}
                height={215}
            />
        </div>
    )
}

export default ResultChartComponent
